export default __webpack_public_path__ + "e0170d107e85b589308480f2357bb052.svg";